<template>
    <div
        class="c-notification"
        :class="'c-notification--' + (notification.type ? notification.type : 'secondary')"
    >
        <div class="c-notification__inner">
            <div
                v-if="notification.title"
                class="c-notification__title"
            >
                {{ notification.title }}
            </div>
            <component
                v-if="isComponent"
                :is="notification.payload.name"
                v-bind="notification.payload.props"
                class="c-notification__content"
                @closeNotification="triggerClose"
            >
            </component>
            <div
                v-else-if="notification.html"
                v-dompurify-html="notification.payload"
                class="c-notification__content"
            >
            </div>
            <div
                v-else
                class="c-notification__content"
                v-text="notification.payload"
            >
            </div>
        </div>
        <div class="c-notification__close">
            <icon-button
                v-if="hasClose"
                :tooltip="trans('common.close')"
                icon="fa-times"
                color="transparent"
                @click="triggerClose"
            ></icon-button>
        </div>
    </div>
</template>

<script>

export default {
    name: 'Notification',
    emits: ['closeNotification'],
    props: {
        notification: {
            type: Object,
            required: true,
        },
    },
    data() {
        return { timer: null };
    },
    computed: {
        isComponent() {
            return _.isObject(this.notification.payload);
        },
        hasClose() {
            return !this.notification.payload?.noClose;
        },
    },
    methods: {
        triggerClose: function () {
            clearTimeout(this.timer);
            this.$emit('closeNotification', this.notification);
        },
    },
    mounted() {
        let timeout = this.notification.hasOwnProperty('timeout') ? this.notification.timeout : true;
        if (timeout) {
            let delay = this.notification.delay || 3000;
            this.timer = setTimeout(() => {
                this.triggerClose(this.notification);
            }, delay);
        }
    },
};

</script>

<style lang="scss" scoped>
@use "@sass/mixins";
@use "@sass/variables";

.c-notification {
    border-radius: 10px;
    box-shadow: 0 0 0 0 rgb(0 0 0 / 1%), 0 0 2px 2px rgb(0 0 0 / 1%) inset;
    color: #000;
    display: flex;
    font-size: 15px;
    padding: 15px;
    position: relative;

    &--alert {
        background: variables.$var-color__danger--lighter;
    }

    &--success {
        background: variables.$var-color__success--lighter;
    }

    &--primary {
        background: variables.$var-color__info--lighter;
    }

    &--secondary {
        background: variables.$var-color__warning--lighter;
    }

    &--dataenrichment {
        background: #dccdfd;
    }

    &__content {
        overflow-wrap: break-word;
        text-wrap: pretty;
    }

    &__close {
        position: absolute;
        right: 0;
        top: 0;
    }
}

</style>
